@if (station?.stationUsage?.transports?.length > 0) {
  <app-station-transport-details [sacClientContext]="null" [station]="station" [stationSet]="null"
    [transport]="station.stationUsage.transports[0]"
  [dashboardContext]="null"></app-station-transport-details>
}
@if (station?.stationUsage?.transports?.length == 0) {
  <app-sac-station-tablet-planned-assignments [station]="station"></app-sac-station-tablet-planned-assignments>
}